import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';
import logo from './img/logo.jpg'

import Swal from 'sweetalert2'
import { api } from '../api';




export default class Homepage extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,
                username:'',
                password:'',




            };
           
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.register = this.register.bind(this);
            this.registerauthor = this.registerauthor.bind(this);

            this.onTextChange = this.onTextChange.bind(this);
           
            
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
          }

        

          register() {
            // window.location.href = '/Register'
             window.location.href = '/kprurun2022/Registerstudent'
             // this.setState({Register
             //   collapse: !this.state.collapse,
             // });
           }

           registerauthor() {
            // window.location.href = '/Register'
             window.location.href = '/kprurun2022/Registerauthorities'
             // this.setState({Register
             //   collapse: !this.state.collapse,
             // });
           }
        
        

           handleSubmit () {

            const dataadd = new FormData();
            dataadd.append("username", this.state.username);
            dataadd.append("password", this.state.password);
          //  dataadd.append("unlockkey", 'A07883EO2050AO8D1');
            
          
          api.get('selectlogin2.php?username='+this.state.username+'&password='+this.state.password)
           
            .then(res => {
                console.log(res);
                if (res.data.length !== 0) {
                  localStorage.setItem('admin_type', res.data[0].type);
                  localStorage.setItem('name', res.data[0].name_member);
                  localStorage.setItem('id_member', res.data[0].id_member);
                  console.log(res.data[0].name_member);
                //  alert("บันทึกสำเร็จ")
                          Swal.fire({
                              title: 'เข้าสู่ระบบสำเร็จ',
                              //text: 'มหาวิทยาลัยราชภัฏกำแพงเพชรขอขอบคุณ',
                              icon: 'success',
                            // showCancelButton: true,
                              confirmButtonText: 'ตกลง',
                            // cancelButtonText: 'No, keep it'
                            }).then((result) => {
                              if (res.data[0].type === '1') {
                                window.location.href = 'https://luckyresortkpp.com/luckyresortkpp/Homelucky'
                              //  window.location.href = 'http://localhost:3000/luckyresortkpp/Pageworkuser'
                              }else if(res.data[0].type === '2' ){
                                window.location.href = 'https://luckyresortkpp.com/luckyresortkpp/Homelucky'
                              //  window.location.href = 'http://localhost:3000/luckyresortkpp/Homelucky'
                              }else if(res.data[0].type === '3' ){
                                window.location.href = 'https://luckyresortkpp.com/luckyresortkpp/Homelucky'
                               // window.location.href = 'http://localhost:3000/luckyresortkpp/Pageworkgraphic'
                              }else if(res.data[0].type === '4' ){
                                window.location.href = 'https://luckyresortkpp.com/luckyresortkpp/Homelucky'
                              //  window.location.href = 'http://localhost:3000/luckyresortkpp/Pageworkmanufacture'
                              }
                              
                            })
                 }else{
                  Swal.fire({
                    title: 'ไม่สามารถเข้าสู่ระบบได้',
                    text: "กรุณาตรวจสอบอีกครั้ง",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'ตกลง',
                   cancelButtonText: 'ยกเลิก'
                  }).then((result) => {
                   
                    
                  })
                 }
            })
               //  this.toggle()
               //  this.getthcouncil()
    
          }
    
      
       



    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }

    render() {
      console.log(this.state.username)
      console.log(this.state.password)
      
        return (
       
                <MDBContainer >
           
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                      <MDBModalHeader toggle={this.toggle}>
                      </MDBModalHeader>
                      <MDBModalBody className="text-center">
                      
                      <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
                      <h3>usermame หรือ password ไม่ถูกต้อง</h3>
                      <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
                      </MDBModalBody>
                    
                    </MDBModal>
                    <br/>

      <MDBRow > 
        <MDBCol md="12" className="d-flex justify-content-center">
              <MDBCard style={{ width: "28rem", marginTop: "1rem" }}  >
                          <MDBCardBody >
                              {/* <div className="text-center">
                              <MDBIcon icon="user-tie" size="4x" className="text-center"/>
                              </div> */}
                              <MDBRow>
                                <MDBCol>
                                  <img  src={logo} className="img-fluid" alt="aligment"  />
                                </MDBCol>
                              </MDBRow>
                              <br/>
                            <MDBCardTitle className="text-center"><h2 className="text-center">  เข้าสู่ระบบ</h2></MDBCardTitle>
                             
                              <div className="mb-2">
                                                      <label>username </label>
                                                      <input className="form-control" onChange={this.onTextChange} name="username"
                                                          value={this.state.username} placeholder="กรุณาระบุ username" required />
                                                  </div>

                                                  <div className="mb-2">
                                                      <label>password </label>
                                                      <input className="form-control" type="password" onChange={this.onTextChange} name="password"
                                                          value={this.state.password} placeholder="กรุณาระบุ password" required />
                                                  </div>

                                                  <div className="mt-3 text-center" >
                                                      <MDBBtn  color="primary" className="text-center" onClick={this.handleSubmit}> <MDBIcon far icon="save" /> เข้าสู่ระบบ</MDBBtn>
                                                  </div>
                          
                            
                          </MDBCardBody>
            </MDBCard>
        </MDBCol>
      </MDBRow>

        
                    </MDBContainer>
                   
     
        )
    }
}
